module.exports = __webpack_public_path__ + "static/media/instagram-480.e5ba7dd7.png";